import { SummaryConfig } from "../../../hooks";
import { ProcedureTypes, TissueTypes } from "../../../models";
import {
    alkGradingSummaryConfig,
    cairsGradingSummaryConfig,
    dmekGradingSummaryConfig,
    dsaekGradingSummaryConfig,
    initialGradingSummaryConfig,
    lenticuleGradingSummaryConfig,
} from ".";

export const getGradingSummaryConfig = (
    tissueType?: TissueTypes,
    procedureType?: ProcedureTypes
): SummaryConfig | undefined => {
    switch (procedureType) {
        case ProcedureTypes.AsgCornea:
        case ProcedureTypes.LabCornealExcision:
            return initialGradingSummaryConfig;
        case ProcedureTypes.CAIRS:
            return cairsGradingSummaryConfig;
        case ProcedureTypes.DMEKStandard:
        case ProcedureTypes.DMEKPreloaded:
        case ProcedureTypes.DMEKPatientReady:
            return dmekGradingSummaryConfig;
        case ProcedureTypes.MicrokeratomeDSAEK:
        case ProcedureTypes.MicrokeratomeDSAEKPreloaded:
        case ProcedureTypes.MicrokeratomeDSAEKTrephined:
            return dsaekGradingSummaryConfig;
        case ProcedureTypes.MicrokeratomeALK:
            return alkGradingSummaryConfig;
        case ProcedureTypes.MicrokeratomeLenticule:
            return lenticuleGradingSummaryConfig;
    }

    switch (tissueType) {
        case TissueTypes.Cairs:
        case TissueTypes.Cairs1:
        case TissueTypes.CairsSeg1:
        case TissueTypes.CairsSeg2:
            return cairsGradingSummaryConfig;
        case TissueTypes.Cornea:
        case TissueTypes.Cornea1:
        case TissueTypes.Cornea2:
        case TissueTypes.CorneaFrill:
        case TissueTypes.WholeGlobe:
            return initialGradingSummaryConfig;
        case TissueTypes.Dmek:
            return dmekGradingSummaryConfig;
        case TissueTypes.Lenticule:
            return lenticuleGradingSummaryConfig;
        case TissueTypes.Precut:
            return dsaekGradingSummaryConfig;
    }

    return undefined;
};
